"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCatalogStatistics = void 0;
const react_1 = require("@apollo/client/react");
const date_fns_1 = require("date-fns");
const get_catalog_data_for_dashboard_query_1 = require("./get-catalog-data-for-dashboard.query");
const client_utils_1 = require("../client.utils");
const localization_1 = require("../../../localization");
const useCatalogStatistics = ({ catalogId, productTreeId, productTreeNodeId, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const shouldSkip = !catalogId || !productTreeId || !productTreeNodeId;
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { networkStatus, data, error } = (0, react_1.useQuery)(get_catalog_data_for_dashboard_query_1.GET_CATALOG_DATA_FOR_DASHBOARD, {
        variables: {
            ids: [catalogId],
            productTreeId,
            productTreeNodeId,
        },
        skip: shouldSkip,
        // no-cache prevents this query from writing to the Apollo cache,
        // avoiding interference with CatalogAttributeDistribution which shares the same cache path.
        fetchPolicy: 'no-cache',
    });
    const catalogNode = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.catalogs) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.node;
    const closedTickets = catalogNode === null || catalogNode === void 0 ? void 0 : catalogNode.closedTickets;
    const products = catalogNode === null || catalogNode === void 0 ? void 0 : catalogNode.products;
    const attributionsSummary = (_e = (_d = catalogNode === null || catalogNode === void 0 ? void 0 : catalogNode.statistics) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.totals;
    const normalizedAttributeBreakdown = (_f = attributionsSummary === null || attributionsSummary === void 0 ? void 0 : attributionsSummary.inferenceAttributes) !== null && _f !== void 0 ? _f : 0;
    const augmentedAttributeBreakdown = (_g = attributionsSummary === null || attributionsSummary === void 0 ? void 0 : attributionsSummary.derivationAttributes) !== null && _g !== void 0 ? _g : 0;
    const totalAttributeBreakdown = normalizedAttributeBreakdown + augmentedAttributeBreakdown;
    const normalizedAttributionBreakdown = (_h = attributionsSummary === null || attributionsSummary === void 0 ? void 0 : attributionsSummary.inferenceValues) !== null && _h !== void 0 ? _h : 0;
    const augmentedAttributionBreakdown = (_j = attributionsSummary === null || attributionsSummary === void 0 ? void 0 : attributionsSummary.derivationValues) !== null && _j !== void 0 ? _j : 0;
    const totalAttributionBreakdown = normalizedAttributionBreakdown + augmentedAttributionBreakdown;
    const getLastUpdatedDate = () => {
        var _a;
        if (!((_a = closedTickets === null || closedTickets === void 0 ? void 0 : closedTickets.edges) === null || _a === void 0 ? void 0 : _a.length))
            return (t({ key: 'NOT_APPLICABLE_SHORT' }));
        const firstTicket = closedTickets.edges[0].node.ticket;
        return (0, date_fns_1.format)((0, date_fns_1.parseISO)(firstTicket.closedAt), 'MMM dd, yyyy');
    };
    const lastUpdated = getLastUpdatedDate();
    const isEmpty = !!error;
    const isLoading = (0, client_utils_1.isQueryLoading)(networkStatus);
    return {
        normalizedAttributeBreakdown,
        augmentedAttributeBreakdown,
        totalAttributeBreakdown,
        normalizedAttributionBreakdown,
        augmentedAttributionBreakdown,
        totalAttributionBreakdown,
        attributionsSummary,
        closedTickets,
        products,
        lastUpdated,
        error,
        isEmpty,
        isLoading,
    };
};
exports.useCatalogStatistics = useCatalogStatistics;
exports.default = exports.useCatalogStatistics;
